// 正式
var timestamp = new Date().getTime()
module.exports = {
  title: '政策通',
  baseUrl: '/', // 正式项目地址
  baseApi: '/', // 本地api请求地址,注意：如果你使用了代理，请设置成'/',
  baseWss:"wss://hycb.hoteas.com/app/",
  APPID: 'xxx',
  APPSECRET: 'xxx',
  $cdn: '',
  ZqcUrl: `/zqclj/index.html?time=${timestamp}#/home`,
  ZqcUrlMatterCon: `/zqclj/index.html?time=${timestamp}#/matterCon`,
  ZqcUrlCompanyone: `/zqclj/index.html?time=${timestamp}#/companytwo`,
}
